export default __webpack_public_path__ + "static/media/February2022.558d4460.png";